import {Component} from 'react';
import {connect} from 'react-redux';

import EventListener from 'topmeteo/general/components/EventListener';

import {popState} from '../actionCreators';

class URLChanger extends Component {

    constructor(props) {
        super(props);

        this.stateDidPop = false;
        this.handlePopState = this.handlePopState.bind(this);
    }

    render() {
        return (
            <EventListener target={window} onPopState={this.handlePopState}>
                {this.props.children}
            </EventListener>
        );
    }

    handlePopState(event) {
        const {handlePopState, popState} = this.props;

        /* History entries we did not create — anchor links, third-party scripts —
           carry no state and say nothing about the state the app should be in. */
        if (!event.state) return;

        this.stateDidPop = true;

        return handlePopState(popState, event);
    }

    componentDidMount() {
        const {data, title, url} = this.props;

        history.replaceState(data, title, url);
    }

    componentDidUpdate() {
        const {data, title, url} = this.props;

        history.pushState(data, title, url);
    }

    shouldComponentUpdate({isDragging, isAnimating, url}) {
        /* Prevent pushing the last state on the history
           again after the history has changed. */
        if (this.stateDidPop) return this.stateDidPop = false;

        /* Force an update when dragging ends. */
        if (this.props.isDragging && isDragging === null) return true;

        /* Force an update when animation ends. */
        if (this.props.isAnimating && isAnimating === false) return true;

        return isDragging === null && isAnimating === false && url !== this.props.url;
    }

}

URLChanger.defaultProps = {
    popState,
    url: null,
    data: null,
    title: 'TopMeteo',
};

const mapStateToProps = ({isDragging, isAnimating}) => ({
    isDragging,
    isAnimating,
});

const mapDispatchToProps = dispatch => ({
    handlePopState: (popState, {state}) => dispatch(popState(state)),
});

export default connect(mapStateToProps, mapDispatchToProps)(URLChanger);
